export const INITIAL_LIST = "INITIAL_LIST";
export const ADD_LIST = "ADD_LIST";
export const ADD_ANNOUNCEMENT_LIST = "ADD_ANNOUNCEMENT_LIST";
export const UPDATE_ANNOUNCEMENT = "UPDATE_ANNOUNCEMENT";
export const SET_SEARCH_QUERY = "SET_SEARCH_QUERY";
export const DELETE_LIST = "DELETE_LIST";